import React from 'react';
import AdminTax from '../components/Admin/AdminTax';

const AdminTaxPage = () => {
  return <AdminTax />;
};

export default AdminTaxPage;